import React from "react";
import "./Spinner.css";
function Spinner() {
  return (
    <div className="Spinner">
      <div class="loader"></div>
    </div>
  );
}

export default Spinner;
